// extracted by mini-css-extract-plugin
export default {"shell":"styles_shell__xPKVT","main":"styles_main__2QvxN","editor":"styles_editor__rihXC","content":"styles_content__AZYq8","meterManContent":"styles_meterManContent__XnqGy"};